import {
  LIBRARY_SALES_TYPE_PAGE_REQUEST,
  LIBRARY_SALES_TYPE_SET_LIST_SALES,
  LIBRARY_SALES_TYPE_SET_OUTLETS,
  LIBRARY_SALES_TYPE_SET_SALES_DETAIL,
  LIBRARY_SALES_TYPE_CLOSE_RIGHT_COLUMN,
  LIBRARY_SALES_TYPE_SET_TOTAL_PAGE,
  LIBRARY_SALES_TYPE_SET_CURRENT_PAGE,
  LIBRARY_SALES_TYPE_ON_CLICK_ROW,
  LIBRARY_SALES_TYPE_OPEN_RIGHT_COLUMN,
  LIBRARY_SALES_TYPE_SET_GRATUITY,
  LIBRARY_SALES_TYPE_SET_MUST_SCROLL_TOP,
  LIBRARY_SALES_TYPE_ON_CLICK_CANCEL,
  LIBRARY_SALES_TYPE_DELETE_SALES_REQUEST,
  LIBRARY_SALES_TYPE_SET_DELETED_SALES,
  LIBRARY_SALES_TYPE_SHOW_DELETE_MODAL,
  LIBRARY_SALES_TYPE_DELETE_SALES,
  LIBRARY_SALES_TYPE_CANCEL_DELETE,
  LIBRARY_SALES_TYPE_HIDE_DELETE_MODAL,
  LIBRARY_SALES_TYPE_ACTIVATED_SALES_REQUEST,
  LIBRARY_SALES_TYPE_SET_ACTIVATED_SALES,
  LIBRARY_SALES_TYPE_SHOW_ACTIVATED_MODAL,
  LIBRARY_SALES_TYPE_ACTIVATED_SALES,
  LIBRARY_SALES_TYPE_HIDE_ACTIVATED_MODAL,
  LIBRARY_SALES_TYPE_CANCEL_ACTIVATED,
  LIBRARY_SALES_TYPE_SET_STATUS_GRATUITY,
  LIBRARY_SALES_TYPE_ON_CHANGE_OUTLET_IDS,
  LIBRARY_SALES_TYPE_ON_CLICK_CREATE_SALES,
  LIBRARY_SALES_TYPE_SUBMIT_FORM_CREATE,
  LIBRARY_SALES_TYPE_SUBMIT_FORM_UPDATE,
  LIBRARY_SALES_TYPE_IS_SUBMITTING_FORM,
  LIBRARY_SALES_TYPE_SUBMIT_FORM_CREATE_ALL_OUTLETS,
  LIBRARY_SALES_TYPE_SHOW_SAVE_TO_ALL_OUTLETS_MODAL,
  LIBRARY_SALES_TYPE_SET_FAILED_OUTLETS,
  LIBRARY_SALES_TYPE_HIDE_SAVE_TO_ALL_OUTLETS_MODAL,
  LIBRARY_SALES_TYPE_SHOW_NO_GRATUITY_MODAL,
  LIBRARY_SALES_TYPE_HIDE_NO_GRATUITY_MODAL,
  LIBRARY_SALES_TYPE_LIST_REQUEST,
  LIBRARY_SALES_TYPE_CHECK_DELETABLE,
  LIBRARY_SALES_TYPE_SHOW_CHECK_DELETABLE_MODAL,
  LIBRARY_SALES_TYPE_SET_SALES_TYPE_RESERVED,
  LIBRARY_SALES_TYPE_RESERVED_FIND_BY_NAME,
} from './constants';

export function salesTypePageRequest() {
  return { type: LIBRARY_SALES_TYPE_PAGE_REQUEST, payload: {} };
}

export function setListSalesType(salesType) {
  return { type: LIBRARY_SALES_TYPE_SET_LIST_SALES, payload: { salesType } };
}

export function setOutlets(outlets) {
  return { type: LIBRARY_SALES_TYPE_SET_OUTLETS, payload: { outlets } };
}

export function setSalesTypeDetail(salesTypeDetail) {
  return {
    type: LIBRARY_SALES_TYPE_SET_SALES_DETAIL,
    payload: { salesTypeDetail },
  };
}

export function closeRightColumn() {
  return { type: LIBRARY_SALES_TYPE_CLOSE_RIGHT_COLUMN, payload: {} };
}

export function setTotalPage(totalPage) {
  return { type: LIBRARY_SALES_TYPE_SET_TOTAL_PAGE, payload: { totalPage } };
}

export function setCurrentPage(currentPage) {
  return {
    type: LIBRARY_SALES_TYPE_SET_CURRENT_PAGE,
    payload: { currentPage },
  };
}

export function onClickRow(salesType) {
  return { type: LIBRARY_SALES_TYPE_ON_CLICK_ROW, payload: { salesType } };
}

export function openRightColumn() {
  return { type: LIBRARY_SALES_TYPE_OPEN_RIGHT_COLUMN, payload: {} };
}

export function setGratuity(gratuity) {
  return { type: LIBRARY_SALES_TYPE_SET_GRATUITY, payload: { gratuity } };
}

export function setMustScrollTop(mustScrollTop) {
  return {
    type: LIBRARY_SALES_TYPE_SET_MUST_SCROLL_TOP,
    payload: { mustScrollTop },
  };
}

export function onClickCancel() {
  return { type: LIBRARY_SALES_TYPE_ON_CLICK_CANCEL, payload: {} };
}
// deleted
export function deleteSalesTypeRequest(deletedSalesType) {
  return {
    type: LIBRARY_SALES_TYPE_DELETE_SALES_REQUEST,
    payload: { deletedSalesType },
  };
}

export function setDeletedSalesType(deletedSalesType) {
  return {
    type: LIBRARY_SALES_TYPE_SET_DELETED_SALES,
    payload: { deletedSalesType },
  };
}

export function showDeleteModal() {
  return { type: LIBRARY_SALES_TYPE_SHOW_DELETE_MODAL, payload: {} };
}

export function deleteSalesType(
  outlets,
  currentOutletId,
  id,
  businessId,
  previousSales
) {
  return {
    type: LIBRARY_SALES_TYPE_DELETE_SALES,
    payload: { outlets, currentOutletId, id, businessId, previousSales },
  };
}

export function cancelDelete() {
  return { type: LIBRARY_SALES_TYPE_CANCEL_DELETE, payload: {} };
}

export function hideDeleteModal() {
  return { type: LIBRARY_SALES_TYPE_HIDE_DELETE_MODAL, payload: {} };
}
// activated
export function activatedSalesTypeRequest(activatedSalesType) {
  return {
    type: LIBRARY_SALES_TYPE_ACTIVATED_SALES_REQUEST,
    payload: { activatedSalesType },
  };
}

export function setActivatedSalesType(activatedSalesType) {
  return {
    type: LIBRARY_SALES_TYPE_SET_ACTIVATED_SALES,
    payload: { activatedSalesType },
  };
}

export function showActivatedModal() {
  return { type: LIBRARY_SALES_TYPE_SHOW_ACTIVATED_MODAL, payload: {} };
}

export function showNoGratuityModal(action) {
  return {
    type: LIBRARY_SALES_TYPE_SHOW_NO_GRATUITY_MODAL,
    payload: { action },
  };
}

export function hideNoGratuityModal() {
  return { type: LIBRARY_SALES_TYPE_HIDE_NO_GRATUITY_MODAL, payload: {} };
}

export function activatedSalesType(
  outlets,
  currentOutletId,
  salesTypeDetail,
  previousSalesType
) {
  return {
    type: LIBRARY_SALES_TYPE_ACTIVATED_SALES,
    payload: { outlets, currentOutletId, salesTypeDetail, previousSalesType },
  };
}

export function hideActivatedModal() {
  return { type: LIBRARY_SALES_TYPE_HIDE_ACTIVATED_MODAL, payload: {} };
}

export function cancelActivated() {
  return { type: LIBRARY_SALES_TYPE_CANCEL_ACTIVATED, payload: {} };
}

export function setGratuityStatusFromSetting(enableGratuity) {
  return {
    type: LIBRARY_SALES_TYPE_SET_STATUS_GRATUITY,
    payload: { enableGratuity },
  };
}

export function onChangeOutletIds(outletIds, businessId) {
  return {
    type: LIBRARY_SALES_TYPE_ON_CHANGE_OUTLET_IDS,
    payload: { outletIds, businessId },
  };
}

export function onClickCreateSalesType() {
  return { type: LIBRARY_SALES_TYPE_ON_CLICK_CREATE_SALES, payload: {} };
}

export function submitFormCreate(data, businessId, previousSalesType) {
  return {
    type: LIBRARY_SALES_TYPE_SUBMIT_FORM_CREATE,
    payload: { data, businessId, previousSalesType },
  };
}

export function submitFormUpdate(
  idSalesType,
  businessId,
  currentSalesType,
  previousSalesType,
  initialSalesType,
  gratuity
) {
  return {
    type: LIBRARY_SALES_TYPE_SUBMIT_FORM_UPDATE,
    payload: {
      idSalesType,
      businessId,
      currentSalesType,
      previousSalesType,
      initialSalesType,
      gratuity,
    },
  };
}

export function isSubmittingForm(isSubmittingForm) {
  return {
    type: LIBRARY_SALES_TYPE_IS_SUBMITTING_FORM,
    payload: { isSubmittingForm },
  };
}

export function submitFormCreateAllOutlets(
  data,
  businessId,
  previousSalesType,
  outlets
) {
  return {
    type: LIBRARY_SALES_TYPE_SUBMIT_FORM_CREATE_ALL_OUTLETS,
    payload: { data, businessId, previousSalesType, outlets },
  };
}

export function showSaveToAllOutletsModal() {
  return {
    type: LIBRARY_SALES_TYPE_SHOW_SAVE_TO_ALL_OUTLETS_MODAL,
    payload: {},
  };
}

export function setFailedOutlets(failedOutlets) {
  return {
    type: LIBRARY_SALES_TYPE_SET_FAILED_OUTLETS,
    payload: { failedOutlets },
  };
}

export function hideSaveToAllOutletsModal() {
  return {
    type: LIBRARY_SALES_TYPE_HIDE_SAVE_TO_ALL_OUTLETS_MODAL,
    payload: {},
  };
}

export function salesTypeRequest(params, businessId, previousSales) {
  return {
    type: LIBRARY_SALES_TYPE_LIST_REQUEST,
    payload: { params, businessId, previousSales },
  };
}

export function checkSalesTypeDeletable(id) {
  return { type: LIBRARY_SALES_TYPE_CHECK_DELETABLE, payload: { id } };
}

export function showSalesTypeDeletableModal(id, showCheckDeletableModal, type) {
  return {
    type: LIBRARY_SALES_TYPE_SHOW_CHECK_DELETABLE_MODAL,
    payload: { id, showCheckDeletableModal, type },
  };
}

export function setSalesTypeReserved(salesTypeReserved) {
  return {
    type: LIBRARY_SALES_TYPE_SET_SALES_TYPE_RESERVED,
    payload: { salesTypeReserved },
  };
}

export function findSalesTypeReservedByName(salesTypeName) {
  return {
    type: LIBRARY_SALES_TYPE_RESERVED_FIND_BY_NAME,
    payload: { salesTypeName },
  };
}
